<template>
  <v-list-tile
    :title="$t('decoderIgnoreTaggingClickToChange')"
    :class="{
      'pb-2': !decoder.ignore_tagging,
    }"
    @click="$emit('toggle')"
  >
    <v-list-tile-content>
      <v-list-tile-title>
        {{ decoder.description }}
      </v-list-tile-title>
      <v-list-tile-sub-title
        :class="{
          'warning--text': decoder.ignore_tagging,
        }"
      >
        <span v-if="!decoder.ignore_tagging">
          {{ $t('decoderIgnoreTaggingEnabled') }}
        </span>
        <span v-else>
          {{ $t('decoderIgnoreTaggingDisabled') }}
        </span>
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-avatar v-if="decoder.ignore_tagging">
      <v-icon color="warning">
        lock
      </v-icon>
    </v-list-tile-avatar>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    decoder: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/DecoderTagSelectExtraTile.vue